module.exports = __webpack_public_path__ + "img/icon-visible.18bea8f1.svg";